<section class="pupil-magic-box-exercise">
  <div *ngIf="errorMessage">
    <div>{{errorMessage}}</div>>
  </div>
  <div class="task type-number">
    <div class="reviewer bluelight_txt">
      <img
        src="{{ main_domain + card.box.risk_character_obj.icon_url }}"
        *ngIf="card && riskCharacterSelected && card.box.risk_character_obj">
      <img
        src="{{ main_domain + card.box.check_character_obj.icon_url }}"
        *ngIf="card && !riskCharacterSelected && card.box.check_character_obj">
      <span *ngIf="card && riskCharacterSelected && card.box.risk_character_obj">
        {{ card.box.risk_character_obj.title }} проверит этот вариант.
      </span>
      <span *ngIf="card && !riskCharacterSelected && card.box.check_character_obj">
        {{ card.box.check_character_obj.title }} проверит этот вариант.
      </span>
    </div>
    <h4 class="task-number bluelight_txt">Задание {{ selectedExerciseIndex + 1 }}</h4>
  </div>
  <div class="pupil-magic-box-exercise__content">
    <div class="answer_table">
      <ul *ngFor="let row of exercise_body; let rowIndex = index" style="margin-bottom: 0 !important;">
        <li *ngFor="let elem of row; let elemIndex = index" class="cell_list"  (click)="selectCell(rowIndex, elemIndex)">
          <div class="dummy"></div>
          <div class="cell" [ngClass]="checkIfCellChosen(rowIndex, elemIndex)">
            <span class="value" *ngIf="elem">{{ elem }}</span>
            <div class="input-group answer active" *ngIf="elem == null">
                <span class="magic_box-cross-icon" (click)="clearCell(rowIndex, elemIndex)">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <defs>
                        <style>.magic_box-close-cls-1,.magic_box-close-cls-2{fill:none;}.magic_box-close-cls-2{stroke:#ccc;stroke-miterlimit:10;stroke-width:2px;} .magic_box-cross-icon:hover .magic_box-close-cls-2{stroke:#999999;stroke-miterlimit:10;stroke-width:2px;}</style>
                      </defs>
                      <title></title>
                      <g id="Слой_2" data-name="Слой 2">
                        <g id="Слой_10" data-name="Слой 10">
                          <rect class="magic_box-close-cls-1" width="24" height="24"/>
                          <line class="magic_box-close-cls-2" x1="1.5" y1="1.5" x2="22.5" y2="22.5"/>
                          <line class="magic_box-close-cls-2" x1="1.5" y1="22.5" x2="22.5" y2="1.5"/>
                        </g>
                      </g>
                    </svg>
                  </span>
              <input
                type="text"
                class="magic_box_input-pupil"
                #input
                readonly="readonly"
                *ngIf="student_answer_array[rowIndex][elemIndex] == null">
              <input
                type="text"
                class="magic_box_input-pupil"
                #input
                readonly="readonly"
                *ngIf="student_answer_array[rowIndex][elemIndex] != null"
                value="{{ student_answer_array[rowIndex][elemIndex] }}">
            </div>
          </div>
        </li>
      </ul>
      <span class="magic_box_hint_text--student" *ngIf="exercise.hint">
        {{ exercise.hint }}
      </span>
    </div>
    <div class="keyboard">
      <div class="keyboard-container">
        <ul class="numbers">
          <li class="keyboard-item" *ngFor="let button of buttons">
            <a (click)="keyboardClicked(button)" appDisTouchmove>
              {{ button }}
            </a>
          </li>
          <li class="keyboard-item">
            <a (click)="keyboardClicked('0')" appDisTouchmove>
              0
            </a>
          </li>
          <li class="keyboard-item"></li>
          <li class="keyboard-item"></li>
          <li>
            <div class="action_btn">
              <a class="backspace" (click)="clearAnswer()" appDisTouchmove>
                <img src="/assets/images/icons/backspace.svg" width="30">
              </a>
              <a class="enter" (click)="checkAnswer()" appDisTouchmove>
                <img src="/assets/images/icons/enter.svg" width="86">
              </a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>
